<template>
    <Popup :open="open" @open="this.$emit('update:open', (open = !open))" :padding="true">
        <Loading :loading="loading" preserveHeight="true">
            <div>
                <p>
                    {{ $t('remove_payment_method') }}
                </p>

                <SinglePaymentMethod :showToggle="false" :paymentMethod="paymentMethod" class="flex flex-col lg:flex-row w-full rounded-md shadow-md border border-white my-6" />

                <div class="flex flex-row flex-wrap gap-4 mt-4">
                    <FormButton class="w-auto" styling="primary xs flex items-center gap-3 text-xs" @click="close()" :value="$t('common_cancel')"> </FormButton>
                    <FormButton class="w-auto" styling="secondary xs flex items-center gap-3 text-xs" @click="process(paymentMethod)" :value="$t('plain_remove')"> </FormButton>
                </div>
            </div>
        </Loading>
    </Popup>
</template>

<script>
import i18next from 'i18next';

export default {
    methods: {
        process() {
            // remove the Payment Method
            this.$store
                .dispatch('payment_methods/delete', this.paymentMethod)
                .then((response) => {
                    this.$toast.success(i18next.t('msg_payment_method_succesfully_removed'));
                    this.$emit('update:open', false);
                    this.$emit('reload');
                })
                .catch((error) => {
                    this.$toast.error(i18next.t('msg_payment_method_error_removing'));
                });
        },
        close() {
            this.$emit('update:open', false);
        }
    },

    data: () => ({
        loading: false
    }),

    props: ['open', 'paymentMethod'],
    emits: ['update:open'],
    watch: {
        open: function () {
            this.$emit('update:open', this.open);
        }
    }
};
</script>
